import React from "react";
import { SpinnerBlock } from "../../Utils/CustomComponent";
import moment from "moment";
import NumberFormat from "react-number-format";

const ACHInfoTab = ({ achData }) => {
  return (
    <section>
      {achData ? (
        <table className="table table-bordered">
          <tbody>
            <tr>
              <td className="fw-bold">Account Type:</td>
              <td>{AccountTypeOptions[achData?.ACH_AccountType]}</td>
              <td className="fw-bold">Recurring ACH Status:</td>
              <td>{ServiceStatus[achData?.ACH_ServiceStatus]}</td>
            </tr>

            <tr>
              <td className="fw-bold">Debit Due Day:</td>
              <td>{achData?.ACH_DebitDueDay}</td>
              <td className="fw-bold">Next Debit Date:</td>
              <td>{achData?.ACH_NextDebitDate}</td>
            </tr>
            <tr>
              <td className="fw-bold">Stop Date:</td>
              <td>{moment(achData?.ACH_StopDate).format("MM/DD/YYYY")}</td>
              <td className="fw-bold">Debit Amount:</td>
              <td>
                {
                  <NumberFormat
                    displayType="text"
                    value={achData?.ACH_DebitAmount}
                    prefix={"$"}
                    customInput={false}
                    fixedDecimalScale={true}
                    decimalScale={2}
                    thousandSeparator={true}
                  />
                }
              </td>
            </tr>
            <tr>
              {/* <td className="fw-bold">Apply Debit As:</td>
              <td>{}</td> */}
              <td className="fw-bold">Debit Frequency:</td>
              <td>{Frequency[achData?.ACH_Frequency]}</td>
            </tr>
          </tbody>
        </table>
      ) : (
        <SpinnerBlock height="10vh" />
      )}
    </section>
  );
};

export default ACHInfoTab;

const Frequency = ["Only Once", "Monthly"];

const ServiceStatus = ["Inactive", "Active"];

const AccountTypeOptions = ["Checking", "Savings"];
